export type ModuleName = "goals"
export const MODULE_NAME: ModuleName = "goals"
